import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { I18NEXT_SERVICE, I18NextModule, ITranslationService, defaultInterpolationFormat } from 'angular-i18next';
import i18next from 'i18next';
import { environment } from '../../../aumico-project-reports/src/environments/environment';
import { values as deCH } from './translation/de-CH';
import { values as deDE } from './translation/de-DE';
import { values as EN } from './translation/en';
import { values as FR } from './translation/fr';
import { values as IT } from './translation/it';

const I18NEXT_RESOURCES = {
    en: { translation: EN },
    'en-US': { translation: EN },
    de: { translation: deCH },
    'de-DE': { translation: deDE },
    'de-CH': { translation: deCH },
    fr: { translation: FR },
    'fr-CH': { translation: FR },
    it: { translation: IT },
    'it-CH': { translation: IT },
};

export function appInit(i18next: ITranslationService) {
    return () =>
        i18next.init({
            supportedLngs: ['en', 'en-US', 'de', 'fr', 'it', 'de-CH', 'de-DE', 'fr-CH', 'it-CH'],
            fallbackLng: 'de-CH',
            lng: 'de-CH', // Set initial language explicitly to prevent auto-detection
            load: 'all',
            debug: environment.enableLocalizationDebugging,
            returnEmptyString: true,
            resources: I18NEXT_RESOURCES,
            cleanCode: true,
            interpolation: {
                format: I18NextModule.interpolationFormat(defaultInterpolationFormat),
                escapeValue: false,
            },
        });
}

export function localeIdFactory(i18next: ITranslationService) {
    return i18next.language;
}

export const I18N_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: appInit,
        deps: [I18NEXT_SERVICE],
        multi: true,
    },
    {
        provide: LOCALE_ID,
        deps: [I18NEXT_SERVICE],
        useFactory: localeIdFactory,
    },
];

window['i18nextEditor'] = i18next; // Expose i18next globally for Editor
